// extracted by mini-css-extract-plugin
export default {"container":"Tenants_container__lDFaI","title":"Tenants_title__29auz","buttonsContainer":"Tenants_buttonsContainer__9PslP","buttonBox":"Tenants_buttonBox__UX-AK"};